export enum ColorByStatusPayment {
  new = 'var(--gray)',
  pending = 'var(--gold)',
  analyze = 'var(--blue)',
  review = 'var(--gold)',
  readyToPay = 'var(--gray)',
  withdrawing = 'var(--green)',
  paid = 'var(--green)',
  paidByFinance = 'var(--green)',
  canceled = 'var(--gold)',
  retry = 'var(--gray)',
  blocked = 'var(--red)',
  unblocked = 'var(--gray)',
  failed = 'var(--red)',
}
